import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/games/the-human-body/_components/organ-game.tsx");
